module.exports = __webpack_public_path__ + "media/images/abstract-good-8032874d1af5d71295664d70a9534e10.png";